import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import {
  LoadingIconModule,
  SmartadminModule,
  SmartadminWizardsModule,
  SmartadminDatatableModule,
  SmartadminValidationModule,
  SmartadminInputModule,
  SharedAngularComponentsAvlaModule,
  AuthElementsModule,
} from 'shared-angular-components-avla';
import {
  CommonsGenericTableAvlaModule,
  GenericTableAvlaModule,
} from 'generic_table_avla_front_components';
import { Select2Module } from 'shared-angular-components-avla/shared/forms/input/select2/select2.module';
import { RetryNotificationMessageService } from 'base-angular-avla';

import { routing } from './carga-archivo.routing';
import { CargaArchivoComponent } from './carga-archivo.component';
import { BulkLoadSinisterComponent } from './components/bulk-load-sinister/bulk-load-sinister.component';
import { BulkLoadStatusPersonComponent } from './components/bulk-load-status-person/bulk-load-status-person.component';

@NgModule({
  imports: [
    CommonModule,
    SmartadminModule,
    SmartadminWizardsModule,
    SmartadminDatatableModule,
    SmartadminValidationModule,
    SmartadminInputModule,
    LoadingIconModule,
    AuthElementsModule,
    ReactiveFormsModule,
    GenericTableAvlaModule,
    CommonsGenericTableAvlaModule,
    SharedAngularComponentsAvlaModule.forRoot(),
    Select2Module,
    routing,
    FormsModule,
  ],
  declarations: [
    CargaArchivoComponent,
    BulkLoadSinisterComponent,
    BulkLoadStatusPersonComponent,
  ],
  exports: [CargaArchivoComponent],
  providers: [RetryNotificationMessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CargaArchivoModule {}
